export default "__VITE_ASSET__CzJECpa9__"